import { deleteBare, getBare } from './httpRequest';

export const fetchPromotionsApi = async ({ searchTerm, first = 0, size = 25 }) => {
  const paginationParams = `first=${first}&size=${size}`;
  const url =
    typeof searchTerm === 'string'
      ? `promotions?searchTerm=${encodeURIComponent(searchTerm)}&${paginationParams}`
      : `promotions?${paginationParams}`;
  const response = await getBare(url);

  return response.data;
};

export const deletePromotionApi = async (venueId, promotionId) => {
  const response = await deleteBare(`venues/${venueId}/promotions/${promotionId}`);

  return response.data;
};
